<template>
  <div class="ride-where-to main">
    <div class="wrapper" v-if="workflow">
      <!-- <div v-if="hasTours" class="tours-btn">
        <span class="button is-primary has-text-weight-semibold" disabled>
          {{ $t("ride.tours") }}
        </span>
      </div> -->
      <span
        v-if="!showBusinessName"
        class="promo-code link has-text-grey"
        @click="enterPromoCode"
      >
        <span v-if="promoCode">
          {{ promoCode }}
        </span>
        <span v-else> {{ $t("promo-code") }}</span>
      </span>
      <img :src="vehicleIcon" @click="showWorkflowsToSuperUser" />
      <h1 class="subtitle">
        <i
          class="fa fa-chevron-left"
          style="padding-right: 8px"
          @click="$emit('close')"
        />
        <span @click="toggleName">{{
          translateTransportType(workflow.name)
        }}</span>
        <span
          v-if="showBusinessName"
          class="business-name"
          style="margin-left: 4px"
          @click="showWorkflowsToSuperUser"
        >
          <i v-if="mainWorkflow">{{ mainWorkflow.business.name }}</i>
          <i v-else style="color: #09264aaa">{{ workflow.business.name }}</i>
        </span>
      </h1>

      <div style="display: flex; margin-top: -10px">
        <div class="left">
          <p><i class="fa fa-circle has-text-info pulse" /></p>
          <p><i class="fa fa-ellipsis-v fa-sm" style="color: grey" /></p>
          <p><i class="fa fa-map-marker-alt has-text-success" /></p>
        </div>
        <div class="right" :class="{ wider: showWider }">
          <div class="field">
            <p class="control has-icons-right">
              <!-- :class="{ 'is-rounded': !showWider, 'is-medium': showWider }" -->
              <input
                ref="pickup"
                v-model="pickupInput"
                class="input is-medium has-text-link"
                :class="{ 'is-rounded': !showWider }"
                :style="settingStyle('pickup')"
                :placeholder="$t('ride.pickup-at')"
                @focus="
                  pickup = null;
                  pickupInput = null;
                  setSetting('pickup');
                "
                @blur="
                  checkResetPickup();
                  showWider = false;
                "
                @keydown="showWider = true"
                @keyup="checkInput"
              />
              <span class="icon is-small is-right">
                <i v-if="pickup" class="fa fa-check" />
                <i v-else class="fa fa-spinner fa-spin" />
              </span>
            </p>
          </div>
          <div class="field">
            <p class="control has-icons-right">
              <!-- :class="{ 'is-rounded': !showWider, 'is-medium': showWider }" -->
              <input
                ref="dropoff"
                v-model="dropoffInput"
                class="input is-medium has-text-link"
                :class="{ 'is-rounded': !showWider }"
                :style="settingStyle('dropoff')"
                :placeholder="whereTo"
                @focus="
                  dropoff = null;
                  dropoffInput = null;
                  setSetting('dropoff');
                "
                @blur="showWider = false"
                @keydown="showWider = true"
                @keyup="checkInput"
              />
              <span class="icon is-small is-right">
                <i v-if="dropoff" class="fa fa-check" />
                <i v-else class="fa fa-search" />
              </span>
            </p>
          </div>
        </div>
      </div>
      <div v-if="showWider" class="background-cover" />

      <div v-if="pickup && dropoff">
        <div
          v-if="warning"
          class="notes-wrapper has-text-danger single-line no-scrollbar"
          @click="tryAgain"
        >
          <i class="fa fa-exclamation-triangle" />&nbsp;{{ warning }}
        </div>
        <div v-else class="notes-wrapper">
          <div v-if="editNotes">
            <textarea
              ref="notes"
              class="textarea is-warning"
              :placeholder="$t('ride.message-for-driver')"
              rows="2"
              v-model="notes"
              @keydown.enter="toggleEditNotes"
            ></textarea>
            <i
              class="fa fa-check-circle has-text-success"
              @click="toggleEditNotes"
            />
          </div>
          <div v-else>
            <p @click="toggleEditNotes">
              <i class="fa fa-pencil-alt has-text-info is-pulled-right" />
              <i v-if="!notes">{{ $t("ride.pickup-notes") }}</i>
              <i v-else class="far fa-comment-alt" />
              <span class="has-text-link">{{ notes }}</span>
            </p>
          </div>
        </div>
        <div
          v-if="warning"
          class="notes-wrapper has-text-primary"
          @click="tryAgain"
        >
          <i class="fa fa-undo-alt fa-lg" />
          {{ $t("ride.edit-locations-try-again") }}
        </div>
        <!-- If locations are valid and fare is computed -->
        <div v-else-if="fare" class="fare-wrapper">
          <i class="fare-word" @click="showDistance">{{ $t("fare") }}</i>
          <span v-if="isFree4Promo" class="fare-amount has-text-success">
            {{ $t("free") }}
          </span>
          <span v-else class="fare-amount has-text-link">
            {{ currency }}{{ fare }}
            <span v-if="!submitReady">Per Pax</span>
          </span>

          <!-- submitReady means final fare computed and pax if necessary -->
          <span v-if="submitReady">
            <span class="button is-light" @click="cashInfo">
              {{ $t("cash") }}
            </span>
            <span
              v-if="pax"
              class="button is-white has-text-weight-medium"
              @click="clearPax"
            >
              {{ pax }} Pax&nbsp;<i class="fa fa-pencil-alt has-text-success" />
            </span>
            <span class="is-pulled-right submit pulse-btn" @click="submit">
              {{ $t("ride.book") }}&nbsp;<i class="fa fa-chevron-right fa-lg" />
            </span>
          </span>
          <!-- Otherwise need to enter pax first -->
          <!-- <span v-else>
            <span class="button is-info" @click="cashInfo"> Enter Pax </span>
          </span> -->
        </div>
        <!-- If calculating fare -->
        <div v-else class="fare-wrapper">
          <i class="fare-word"
            >{{ $t("ride.calculating-fare") }}&nbsp;
            <i class="fa fa-spinner fa-spin has-text-link" />
          </i>
        </div>

        <div v-if="fare && !submitReady" class="pax-selector">
          <p>
            <i class="fa fa-users has-text-success" />
            {{ $t("transport.how-many-passengers") }}
          </p>
          <div class="buttons is-centered">
            <button
              v-for="n in maxPax"
              :key="n"
              class="button is-light is-medium has-text-link"
              style="width: 14vw"
              @click="setPax(n)"
            >
              {{ n }}
            </button>
          </div>
        </div>

        <div style="margin-top: 10px">
          <RideDetailsMap
            :pickup="pickup"
            :dropoff="dropoff"
            :showRoute="!warning"
            :route="drivingRoute"
            :key="drivingRoute"
          />
        </div>
      </div>
      <div v-else>
        <div class="buttons is-flex">
          <span
            class="button"
            :class="{ 'greyed-out': settingDropoff }"
            @click="currentLocationClick"
            v-ripple
          >
            <i class="fa fa-circle has-text-info fa-sm pulse" />
            <i style="margin-left: 8px">{{
              $t("passenger.current-location")
            }}</i>
          </span>
          <span class="button" @click="chooseOnMap">
            <i class="fa fa-globe-asia has-text-info" />
            <i style="margin-left: 8px">{{ $t("ride.choose-on-map") }}</i>
          </span>
        </div>

        <div v-if="yourLocations.length" class="stops-wrapper no-scrollbar">
          <div class="list">
            <span
              v-for="(l, i) in yourLocations"
              :key="i"
              class="list-item is-pointer"
              @click="chooseFrequentLocation(l)"
              v-ripple
            >
              <span class="stop-name no-scrollbar">
                <i class="fa fa-history fa-sm" style="opacity: 0.7" />
                {{ shortenString(l.name, 35) }}
              </span></span
            >
          </div>
        </div>
      </div>
    </div>

    <fade-transition>
      <RideSetLocation
        v-if="showLocationMap"
        :stopType="setting"
        @setLocation="setLocation"
        @close="showLocationMap = false"
      />
    </fade-transition>

    <slide-y-down-transition>
      <RideWorkflowsList
        v-if="showWorkflowsList"
        :name="workflow.name"
        @close="showWorkflowsList = false"
      />
    </slide-y-down-transition>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import $Scriptjs from "scriptjs";
import vehicles from "@/vehicles";
import codes from "@/codes";
import geo from "@/geo";

import RideSetLocation from "@/components/RideSetLocation.vue";
import RideDetailsMap from "@/components/RideDetailsMap.vue";
import RideWorkflowsList from "@/components/RideWorkflowsList.vue";

export default {
  name: "RideWhereTo",
  components: {
    RideSetLocation,
    RideDetailsMap,
    RideWorkflowsList,
  },
  props: {
    workflow: Object, // transport workflow, should be array
  },
  data() {
    return {
      promoCode: null,
      autocomplete: null,
      pickupInput: null,
      dropoffInput: null,
      pickup: null,
      dropoff: null,
      setting: null, // "pickup" or "dropoff"
      timer: 0,
      showWider: false,
      notes: null,
      editNotes: false,
      showLocationMap: false,
      warning: null,
      drivingDist: null,
      drivingRoute: null, // encoded
      fare: null,
      pax: null, // will be set if required
      isPerPax: false,
      showWorkflowsList: false, // for super user
      showBusinessName: false,
      mainWorkflow: null,
      backupWorkflows: [],
      fallbackRadius: 10000,
      fallbackMaxDistance: 25000,
      loginCallback: "RIDE_WHERE_TO_LOGIN_CALLBACK",
    };
  },
  computed: {
    isFree4Promo() {
      return this.promoCode === "FREE4";
    },
    currentLocation() {
      return this.$t("passenger.current-location");
    },
    pinLocation() {
      return this.$t("ride.pin-location");
    },
    hasTours() {
      var transportType = this.workflow.name;
      var workflows = this.workflows.filter((t) => t.name === transportType);
      return workflows.find(
        (w) => w.data.tours_hourly || w.data.tours_itinerary
      );
    },
    whereTo() {
      return this.$t("where-to");
    },
    pickupName() {
      if (!this.pickup) return null;
      if (this.pickup.current_location && this.pickup.name) {
        if (this.timer % 2 && this.pickup.name) return this.pickup.name;
        else return `${this.currentLocation} - ${this.pickup.name}`;
      }
      if (this.pickup.current_location) {
        return this.currentLocation;
      }
      return this.pickup.name || this.pinLocation;
    },
    dropoffName() {
      if (!this.dropoff) return null;
      return this.dropoff.name || this.pinLocation;
    },
    settingPickup() {
      return this.setting === "pickup";
    },
    settingDropoff() {
      return this.setting === "dropoff";
    },
    workflowStops() {
      return this.workflow.data.stops;
    },
    yourLocations() {
      return this.$store.state.userStops.filter((s) => s.name); // filter blank string names
      // if (this.workflowStops) return this.workflowStops;
      // return [ { name: "Kids Kingdom, Soi 47", lat: 13.729986, lon: 100.574575 } ];
    },
    vehicleIcon() {
      return vehicles.img(this.workflow.name);
    },
    feePerKM() {
      if (!this.workflow.data) return 20;
      return this.workflow.data.fee_per_km || 15; // default to 15 baht per km
    },
    minFare() {
      if (!this.workflow.data) return 20;
      return this.workflow.data.min_fare || 15; // default to 15 baht min fare
    },
    currency() {
      return this.currencySymbol("th");
    },
    pickupAreaPolygon() {
      return this.workflow.data.pickup_area_polygon;
    },
    pickupAreaRadius() {
      return this.workflow.data.pickup_area_radius || this.fallbackRadius;
    },
    maxDistance() {
      return this.workflow.data.max_distance || this.fallbackMaxDistance;
    },
    maxPax() {
      return this.workflow.data.max_pax || 10;
    },
    fixedFarePax() {
      return this.workflow.data.fixed_fare_pax;
    },
    submitReady() {
      if (this.isPerPax && !this.pax) return false;
      return true;
    },
    workflows() {
      var transports = this.$store.state.transport; // all the nearby transport workflows
      transports = transports.filter((t) => t.name === this.workflow.name);
      transports = transports.filter((t) => t.state !== "inactive");
      return transports; // get the relevant ones
    },
    country() {
      return this.workflow.business.country;
    },
    nearbyStationsIDs() {
      var ids = this.backupWorkflows.map((w) => w.id);
      return ids.join();
    },
  },
  mounted() {
    var url = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(url, () => this.setupAutocomplete());

    setTimeout(() => this.$refs.dropoff.focus(), 400);
    // this.setting = "dropoff";

    this.setPickup(null);
    // this.oscillatePickupInput();

    EventBus.$on(this.loginCallback, () => this.submit());
  },
  methods: {
    enterPromoCode() {
      this.log("ride_promo_code", "open");
      var blue = this.bulmaColor("info");
      var msg = this.$t("promos.enter-promo-code");
      this.$swal({
        title: `<i class='fa fa-gift' style='color:${blue}'></i>`,
        html: `<div style='font-size:1.2em'>${msg}</div>`,
        input: "text",
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: this.$t("submit"),
        confirmButtonColor: blue,
      }).then((val) => {
        if (!val.value) return;
        var txt = val.value.toLowerCase();
        this.log("ride_promo_code", txt);
        if (txt.startsWith("+")) {
          this.promoCode = txt; // phone number
          return;
        }
        if (codes.lookup(txt)) {
          this.promoCode = codes.lookup(txt);
          return;
        }
        if (txt === "free4") {
          this.checkPromoCodeFraud();
          this.promoCode = "FREE4";
          this.checkFree4Promo();
          return;
        }
        this.warningToast(this.$t("promos.invalid-code"), "top");
      });
    },
    checkPromoCodeFraud() {
      this.$store
        .dispatch("checkFraudPromoCancellations")
        .then((res) => {
          if (res.data === 0) return;
          this.promoCode = null;
          var msg = this.$t("promos.cancelled-too-many-times");
          this.errorToast(msg, "top", 1000 * 20); // 20 seconds
        })
        .catch((err) => console.error("checkPromoCodeFraud", err));
    },
    checkFree4Promo() {
      var opts = { hour: "2-digit", hour12: false, timeZone: "Asia/Bangkok" };
      var hour = parseInt(new Date().toLocaleString("en-GB", opts));
      if (
        hour >= 8 &&
        hour <= 21 &&
        this.drivingDist < 4000 &&
        this.workflow.name.includes("Moto")
      ) {
        this.successToast("FREE4 Promo Applied!");
        return true;
      }
      this.promoCode = null; // reset
      var msg = this.$t("promos.free4-alert");
      this.warningAlert(msg);
      return false;
    },
    oscillatePickupInput() {
      setInterval(() => {
        this.timer += 1; // oscillates pickup input
        if (this.pickupName) this.pickupInput = this.pickupName;
      }, 2000);
    },
    showDistance() {
      var msg = `Driving distance ${this.drivingDist}m`;
      this.infoToast(msg, "top");
    },
    setSetting(type) {
      this.setting = type; // 'pickup' or 'dropoff'
      this.fare = null;
      this.pax = 0;
    },
    setPax(n) {
      this.pax = n;
      this.fare = this.fare * n;
    },
    clearPax() {
      this.pax = 0;
      this.fare = this.fixedFarePax; // reset fare
    },
    cashInfo() {
      var msg = `You can pay the driver in cash,<br>PromptPay or local bank transfer`;
      this.infoToast(msg, "top", 10 * 1000); // hidden by map z-index issue...
    },
    toggleName() {
      this.showBusinessName = !this.showBusinessName;
    },
    showWorkflowsToSuperUser() {
      if (this.isSuperUser()) this.showWorkflowsList = true;
    },
    currentLocationClick() {
      if (this.settingDropoff) {
        var msg = "Destination should not<br>be your current location";
        this.infoToast(msg, "top");
      } else {
        this.setPickup(null);
        this.next();
      }
    },
    next() {
      setTimeout(() => {
        if (this.settingPickup) this.$refs.dropoff.focus();
      }, 400);
    },
    tryAgain() {
      this.dropoff = null;
      this.setting = "dropoff";
    },
    settingStyle(val) {
      if (this.setting !== val) return null;
      return `background-color: #f1ffed`;
    },
    toggleEditNotes() {
      this.editNotes = !this.editNotes;
      if (this.editNotes) {
        setTimeout(() => this.$refs.notes.focus(), 300); // on focus
      } else {
        if (this.notes) this.pickup.name += ` - ${this.notes}`;
      }
    },
    checkInput(e) {
      console.log("checkInput", e.target.value);
      if (!e.target.value.length) this.showWider = false;
    },
    chooseOnMap() {
      this.showLocationMap = true;
    },
    chooseFrequentLocation(stop) {
      setTimeout(() => {
        if (this.settingDropoff) this.setDropoff(stop);
        else this.setPickup(stop);
      }, 300);
    },
    checkResetPickup() {
      setTimeout(() => {
        if (!this.pickup && !this.showLocationMap) this.setPickup(null);
      }, 1000);
    },
    setDropoff(stop) {
      this.dropoff = stop;
      this.dropoffInput = this.dropoffName;
      this.setting = null;
      this.checkFare();
    },
    setPickup(stop) {
      if (stop) this.pickup = stop;
      else {
        var coords = this.$store.getters.getUserLatLon;
        this.pickup = {
          current_location: true,
          name: "", //"Pin Location",
          lat: coords.lat,
          lon: coords.lon,
        };
        this.reverseGeocode(coords);
      }
      this.pickupInput = this.pickup.name || this.currentLocation;
      if (!this.dropoff) this.next();
      else this.setting = null;
      this.checkFare();
    },
    checkFare() {
      this.findRelevantWorkflows(); // set main and backup workflows
      this.warning = null; // clear
      if (!this.pickup || !this.dropoff) return;
      if (this.closeToStation()) return;
      if (this.invalidTripDistance()) return; // sets estimated distance
      if (this.invalidPickupLocation()) {
        return (this.warning = "Outside pickup area for this fleet"); // no valid wins for pickup location
      }
      // now compute actual driving route if possible for fare
      this.getDrivingRouteAndSetFare();
      // this.fare = Math.round((this.feePerKM * this.drivingDist) / 1000);
      // if (this.fare < this.minFare) this.fare = this.minFare;
    },
    setFare() {
      // first check if fixed_fare_pax
      if (this.fixedFarePax && this.checkDropoffInArea()) {
        this.fare = this.fixedFarePax; //`${this.fixedFarePax} Per Person`;
        this.isPerPax = true;
        return;
      }

      // otherwise use standard distance based fare
      var fare = Math.round((this.feePerKM * this.drivingDist) / 1000);
      this.fare = this.roundUp(fare, 5); // round up to 5 baht interval
      if (this.fare < this.minFare) this.fare = this.minFare;

      if (this.isFree4Promo) this.checkFree4Promo();
    },
    getDrivingRouteAndSetFare() {
      var o = { pickup: this.pickup, dropoff: this.dropoff };
      this.$store
        .dispatch("drivingRoute", o)
        .then((obj) => {
          this.console("getDrivingRoute", obj);
          this.drivingDist = obj.distance; // update to actual driving distance
          this.drivingRoute = obj.encoded;
          // this.drawDrivingRoute(obj.encoded);
        })
        .catch((err) => console.error("drivingRoute error", err))
        .finally(() => this.setFare());
    },
    closeToStation() {
      var dist = geo.distance(this.pickup, this.workflow.business);
      if (dist < 50) {
        this.warning = this.$t("ride.pickup-next-to-station");
        return true;
      }
      return false;
    },
    invalidTripDistance() {
      var dist = geo.distanceToUserInMeters(this.pickup, this.dropoff);
      this.drivingDist = dist * 1.25; // estimated driving distance
      if (this.drivingDist < 30) {
        this.warning = this.$t("ride.locations-too-close-together"); //`Locations are too close together`;
        return true;
      }
      if (this.drivingDist < this.maxDistance) return false; // okay, it's not invalid, check max dist on workflow
      var maxDistanceKM = Math.round(this.maxDistance / 1000);
      var currentDistance = Math.round(this.drivingDist / 1000);
      this.warning = `Max trip distance is ${maxDistanceKM}km (~${currentDistance}km)`; // should depend on workflow?
      return true;
    },
    invalidPickupLocation() {
      if (!this.mainWorkflow) return true;
      return false;
      // // check if inside polygon
      // if (this.pickupAreaPolygon) {
      //   var gju = require("geojson-utils");
      //   var coords = [this.pickup.lon, this.pickup.lat];
      //   var point = { type: "Point", coordinates: coords };
      //   var polygon = {
      //     type: "Polygon",
      //     coordinates: this.pickupAreaPolygon, // JSON.parse(this.pickupAreaPolygon),
      //   };
      //   if (gju.pointInPolygon(point, polygon)) return false;
      //   this.warning = "Outside pickup area for this fleet"; // should refactor
      //   return true;
      // }
      // // if no polygon use radius instead
      // var dist = geo.distance(this.pickup, this.workflow.business); // distanceToUserInMeters
      // if (dist < this.pickupAreaRadius) return false; // okay it's inside area
      // this.warning = "Outside pickup area for this fleet"; // should refactor
      // return true;
    },
    // func to check fixed_fare_pax usage
    checkDropoffInArea() {
      this.isPerPax = false; // first  reset this to false
      var w = this.mainWorkflow;
      var gju = require("geojson-utils");
      var coords = [this.dropoff.lon, this.dropoff.lat];
      var point = { type: "Point", coordinates: coords };
      var polygon = w.data.pickup_area_polygon;
      // var radius = w.data.pickup_area_radius || 1000; // 1km radius default
      if (polygon) {
        var geojson = { type: "Polygon", coordinates: polygon };
        if (gju.pointInPolygon(point, geojson)) return true;
        return false;
      }
      // otherwise use radius
      var dist = geo.distance(this.dropoff, w.business); // distanceToUserInMeters
      if (dist < this.pickupAreaRadius) return true; // okay it's inside area
      return false;
    },
    checkPickupInArea(w) {
      var gju = require("geojson-utils");
      var coords = [this.pickup.lon, this.pickup.lat];
      var point = { type: "Point", coordinates: coords };
      var polygon = w.data.pickup_area_polygon;
      // var radius = w.data.pickup_area_radius || 1000; // 1km radius default
      if (polygon) {
        var geojson = { type: "Polygon", coordinates: polygon };
        if (gju.pointInPolygon(point, geojson)) return true;
        return false;
      }
      // otherwise use radius
      var dist = geo.distance(this.pickup, w.business); // distanceToUserInMeters
      if (dist < this.pickupAreaRadius) return true; // okay it's inside area
      return false;
    },
    checkPickupInExpandedArea(w) {
      var radius = 2000; // 2km expanded radius default
      var dist = geo.distance(this.pickup, w.business); // distanceToUserInMeters
      if (dist < radius) return true; // okay it's inside area
      return false;
    },
    findRelevantWorkflows() {
      this.mainWorkflow = null; // reset
      this.backupWorkflows = []; // reset
      // this.workflows.forEach((w) => { }
      for (var i = 0; i < this.workflows.length; i++) {
        var w = this.workflows[i];
        if (this.checkPickupInArea(w)) {
          if (!this.mainWorkflow) this.mainWorkflow = w;
          else this.backupWorkflows.push(w);
        } else if (this.checkPickupInExpandedArea(w)) {
          this.backupWorkflows.push(w);
        }
      }
      if (!this.mainWorkflow && this.backupWorkflows.length) {
        this.mainWorkflow = this.backupWorkflows[0];
        this.backupWorkflows.shift(); // remove first element
      }
    },
    reverseGeocode(coords) {
      this.$store
        .dispatch("reverseGeocode", coords)
        .then((res) => {
          this.console("reverseGeocode", res);
          if (!res.data.address.road) return; // don't set if unknown road
          this.pickup.name = res.data.address.road; // TODO translate road
          if (this.pickup.current_location) {
            this.pickupInput += ` - ${this.pickup.name}`;
          }
        })
        .catch((err) => console.error("reverseGeocode error", err));
    },
    setLocation(val) {
      this.showLocationMap = false;
      this.console("setLocation", val);
      if (val.stop_type === "pickup") {
        this.setPickup(val);
        // check if valid pickup, e.g. not too close to a win, not outside of pickup area
      } else {
        this.setDropoff(val);
        // check if valid dropoff, e.g. not too far
      }
    },
    setupAutocomplete() {
      this.initGoogle("pickup");
      this.initGoogle("dropoff");
    },
    initGoogle(ref) {
      var opts = {
        types: [],
        componentRestrictions: { country: this.country },
      };
      var el = this.$refs[ref];
      var autocomplete = new window.google.maps.places.Autocomplete(el, opts);
      this.geolocate(autocomplete); // will bias google places to current location

      autocomplete.addListener("place_changed", () => {
        var place = autocomplete.getPlace();
        var stop = {
          name: place.name,
          lat: place.geometry.location.lat(),
          lon: place.geometry.location.lng(),
        };
        if (ref === "pickup") this.setPickup(stop);
        else this.setDropoff(stop);
      });
    },
    // Bias autocomplete to the user geolocation,
    geolocate(autocomplete) {
      if (!this.$store.getters.getUserLocation) return;
      var coords = {
        lat: this.$store.getters.getUserLocation[0],
        lng: this.$store.getters.getUserLocation[1],
      };
      var circle = new google.maps.Circle({ center: coords, radius: 25000 });
      autocomplete.setBounds(circle.getBounds());
    },
    // nearbyStations() {
    //   return this.backupWorkflows.join();
    //   // var ids = this.backupWorkflows.map((w) => w.id);
    //   // return ids.join();
    // },
    submit() {
      // added login check
      var msg = this.$t("menu.one-last-thing");
      if (!this.smsLoginOkay(msg, this.loginCallback)) return;
      if (!this.checkMobileNumber()) return; // legacy FB/LINE logins may not have a phone number yet

      if (this.editNotes) this.toggleEditNotes(); // in case user didn't save the notes already
      this.createTransaction();
    },
    createTransaction() {
      var w = this.mainWorkflow; //this.workflow;
      var fare = {
        version: "v1",
        price: this.fare, // show driver
        discount: 0, // show customer
        cash: this.fare, // cash + tukpay = price
        tukpay: 0, // free to play around with this
        distance: this.drivingDist,
      };
      if (this.isFree4Promo) {
        fare.tukpay = fare.cash;
        fare.discount = fare.cash;
        fare.cash = 0;
      }
      var data = {
        pickup_stop: this.pickup,
        dropoff_stop: this.dropoff,
        nearby_stations: this.nearbyStationsIDs, // null if not allowed
        fare: fare,
        agent: false,
      };
      if (this.pax) data.pax = this.pax;
      if (this.drivingRoute) data.predicted_route = this.drivingRoute;
      if (this.promoCode) data.promo_code = this.promoCode;
      var loader = this.loadingDots("gold");
      this.$store
        .dispatch("createTransactionNearby", {
          workflow_id: w.id,
          workflow_type_name: w.workflow_type_name,
          business_id: w.business.id,
          created_by: this.$store.state.user.id,
          handled_by: null, //this.$store.state.selectedDriver,
          data: data,
        })
        .then((res) => {
          this.updateTransactionsForCustomer(false);
          this.$swal({
            title: this.$t("transport.waiting-for-confirmation"),
            showConfirmButton: false,
            timer: 2000,
          });
          this.$emit("close");
          // this.goto("tuktuk");
          this.goto("/ride_booking/" + res.data.id); // transaciton id
        })
        .catch((err) => {
          this.console("ride create transaction error", err);
          this.apiError(err); // could check for err.message === "No worker exists"
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  /* background-color: ivory; */
  background-color: whitesmoke;
  z-index: 21;
  /* random z-index higher than modal << nope, higher than back button which is 20 */
  overflow: hidden;
}
.wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
  overflow: hidden;
}
.stops-wrapper {
  height: calc(100vh - 200px);
  overflow: auto;
  /* padding: 4px; */
  /* padding-top: 2px; */
  padding-bottom: 56px;
}
.stops-wrapper .list {
  margin: 1px;
}
.list-item {
  padding: 12px;
}
.subtitle {
  color: grey;
  font-weight: 450;
  /* margin-left: 45px; */
  margin-top: 6px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  /* background-color: #333; */
}
.tours-btn {
  position: absolute;
  right: 55px;
  top: 10px;
}
.key {
  font-weight: 550;
  color: rgba(84, 84, 84, 0.7);
  padding-right: 0;
}
input::-webkit-input-placeholder {
  /* color: #2693da !important; */
  /* color: rgb(0, 198, 69); */
  color: #aaa;
  font-weight: 500;
  font-style: italic;
}
.left {
  height: 80px;
  width: 30px;
  margin-top: 6px;
}
.right {
  width: calc(100vw - 30px);
}
.left p {
  width: 20px;
  text-align: center;
  padding: 3px;
}
.notes-wrapper {
  padding: 10px;
  margin-top: 10px;
  background-color: white;
  border-radius: 3px;
  border: 1px solid #eee;
}
.fare-wrapper {
  padding: 4px 10px;
  margin-top: 10px;
  background-color: white;
  border-radius: 3px;
  border: 1px solid #eee;
}
.fare-wrapper .button {
  padding: 8px;
}
.submit {
  position: absolute;
  right: 12px;
  margin-top: -4px;
  padding: 10px 15px;
  /* background-color: #00d1b2; */
  background-color: #24d168;
  color: white;
  /* font-size: 1.em; */
  font-weight: 500;
  /* #35AC5E #00D1B2 */
  border-radius: 10px;
  cursor: pointer;
}
.wider {
  position: absolute;
  left: 0;
  width: 100vw;
  /* margin-top: -7px; */
}
.wider .input {
  /* border-radius: 0; */
}
.fare-word {
  display: inline-block;
  margin: 6px 0;
  font-weight: 500;
}
.fare-amount {
  display: inline-block;
  margin: 6px 10px;
  font-weight: 550;
}
img {
  position: absolute;
  right: 12px;
  height: 35px;
  /* background-color: white; */
  padding: 1px;
  border-radius: 3px;
}
.business-name {
  font-size: 0.8em;
  color: #3273dc;
}
.fa-pencil-alt {
  margin-top: 3px;
  opacity: 0.7;
}
.fa-check-circle {
  position: absolute;
  right: 30px;
  /* margin-top: -25px; */
  font-size: 1.7em;
  margin-top: -34px;
}
.fa-comment-alt {
  margin-right: 6px;
  opacity: 0.6;
}
.is-flex {
  white-space: nowrap !important;
}
.buttons.is-flex {
  margin-top: 15px;
  margin-bottom: 0px;
}
.is-flex .button {
  flex: 1;
  justify-content: flex-start;
  padding: 20px 12px;
  /* text-overflow: ellipsis; */
  /* max-width: 45vw; */
}
.stop-name {
  display: inline-block;
  max-width: calc(100vw - 60px);
  white-space: nowrap;
  overflow: auto;
  vertical-align: bottom;
}
.greyed-out {
  opacity: 0.7;
}
.pax-selector {
  position: fixed;
  left: 0;
  padding: 10px;
  padding-bottom: 20px;
  background-color: rgba(255, 255, 0255, 1);
  /* border-radius: 10px; */
  margin-top: -3px;
  z-index: 2;
}
.pax-selector p {
  text-align: center;
  font-size: 1.2em;
  margin-bottom: 12px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
}
.pulse {
  font-size: 0.8em;
  border-radius: 50%;
  animation: shadow-pulse 2s 999;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px cyan;
  }
  100% {
    box-shadow: 0 0 0 4px rgba(0, 255, 255, 0.4);
  }
}
.pulse-btn {
  animation: shadow-pulse-gold 2s ease-out infinite;
  border-radius: 3px;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: inset 0 0 0 0px rgba(255, 255, 0, 1);
  }
  50% {
    box-shadow: inset 0 0 0 6px rgba(255, 255, 0, 0.7);
  }
  100% {
    box-shadow: inset 0 0 0 0px rgba(255, 255, 0, 1);
  }
}
@keyframes shadow-pulse-green {
  0% {
    box-shadow: inset 0 0 0 0px lightgreen;
  }
  100% {
    box-shadow: inset 0 0 0 6px rgba(144, 238, 144, 0.5);
  }
}
.promo-code {
  position: absolute;
  right: 55px;
  top: 16px;
  padding: 0 4px;
  font-size: 1em;
  height: 1.5em;
  background-color: rgba(255, 255, 255, 0);
}
.link {
  border-bottom: 1px #ccc dotted;
}
.background-cover {
  background-color: whitesmoke;
  height: 90vh;
}
</style>

<style lang="scss">
// puts the google places autocomplete dropdown results above this modal
// #ride-where-to-autocomplete {
.pac-container {
  z-index: 1101 !important;
}
// }
</style>